export const lifetimeConfigTypeOfOperation = {
  continous: 'continous',
  intermittent: 'intermittent',
} as const;

export type LifetimeConfigTypeOfOperation =
  (typeof lifetimeConfigTypeOfOperation)[keyof typeof lifetimeConfigTypeOfOperation];

export const OppositeMaterialMap = {
  '1': 'CF53',
  '2': 'X105_X90',
  '6': 'V2A',
  '8': 'ALU_HC',
  '9': 'CF53_CHROMED',
  '3': 'FREE_CUTTING_STEEL',
  '4': 'ST37',
} as const;
export type OppositeMaterialKeyType = keyof typeof OppositeMaterialMap;
